<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="sendCopy"
            type="checkbox"
            name="sendCopy"
            :value="formData.sendCopy"
            @click="$emit('send-copy', !formData.sendCopy)"
          />
          <label for="sendCopy" class="form__label">
            Chcę otrzymać na maila kopię briefu
          </label>
        </div>
        <table class="brief-form__table">
          <thead hidden>
            <tr>
              <th>pytanie</th>
              <th>odpowiedz</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Nazwa firmy</td>
              <td>{{ formData.companyName }}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{ formData.email }}</td>
            </tr>
            <tr>
              <td>Branża / obszar działania</td>
              <td>{{ formData.industry }}</td>
            </tr>
            <tr>
              <td>Oferowane usługi / produkty</td>
              <td>{{ formData.services }}</td>
            </tr>
            <tr v-if="formData.clients">
              <td>Kim są Twoi klienci?</td>
              <td>{{ formData.clients }}</td>
            </tr>
            <tr v-if="formData.competition">
              <td>Konkurencja (wskaż firmy z tej samej branży)</td>
              <td>{{ formData.competition }}</td>
            </tr>
            <tr>
              <td>Czego potrzebujesz?</td>
              <td>
                <span v-for="(item, index) in formData.whatNeed" :key="item">
                  <template v-if="item !== ''">
                    <template v-if="index !== 0">, </template>
                    {{ item }}</template
                  >
                </span>
                <span v-if="formData.whatNeedDetails">
                  <template v-if="formData.whatNeed.length > 0">, </template>
                  {{ formData.whatNeedDetails }}
                </span>
              </td>
            </tr>
            <tr>
              <td>Jakie zadanie ma spełniać Twoja strona?</td>
              <td>
                <span v-for="(item, index) in formData.siteJob" :key="item">
                  <template v-if="item !== ''">
                    <template v-if="index !== 0">, </template>
                    {{ item }}
                  </template>
                </span>
                <span v-if="formData.siteJobOther">
                  <template v-if="formData.siteJob.length > 0">, </template>
                  {{ formData.siteJobOther }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                Posiadasz firmowy znak czy mamy go dla Ciebie przygotować?
              </td>
              <td>
                <template v-if="formData.needLogo">
                  chcę ofertę na logo
                </template>
                <template v-if="formData.needLogo && formData.haveLogo"
                  >, <br />
                  jednocześnie
                </template>
                <template v-if="formData.haveLogo">
                  posiadam logo
                  <template v-for="image in formData.logoImg">
                    <br :key="`${image.name}-1`" />
                    <br :key="`${image.name}-2`" />
                    <img
                      :src="image.dataURL"
                      :alt="image.name"
                      :key="image.name"
                    />
                  </template>
                </template>
              </td>
            </tr>
            <tr>
              <td>
                Jakimi materiałami do wykorzystania na stronie dysponujesz?
              </td>
              <td>
                <span
                  v-for="(item, index) in formData.siteMaterials"
                  :key="item"
                >
                  <template v-if="item !== ''"
                    ><template v-if="index !== 0">, </template>
                    {{ item }}
                  </template>
                </span>
                <span v-if="formData.siteOtherMaterials">
                  <template v-if="formData.siteMaterials.length > 0"
                    >,
                  </template>
                  {{ formData.siteOtherMaterials }}
                </span>
              </td>
            </tr>
            <tr>
              <td>W jakich barwach widzisz swoją stronę?</td>
              <td>
                <span v-for="(item, index) in formData.siteColors" :key="item">
                  <template v-if="item !== ''">
                    <template v-if="index !== 0">, </template>
                    {{ item }}
                  </template>
                </span>
              </td>
            </tr>
            <tr>
              <td>Określ styl swojej wymarzonej strony:</td>
              <td>
                <span v-for="(item, index) in formData.siteStyle" :key="item">
                  <template v-if="item !== ''">
                    <template v-if="index !== 0">, </template>
                    {{ item }}
                  </template>
                </span>
                <span v-if="formData.siteOtherStyles">
                  <template v-if="formData.siteOtherStyles.length > 0"
                    >,
                  </template>
                  {{ formData.siteOtherStyles }}
                </span>
              </td>
            </tr>
            <tr v-if="!formData.inspirationsSitesSkip">
              <td>Podziel się linkami stron, które przypadły Ci do gustu:</td>
              <td>
                <span
                  v-for="(item, index) in formData.inspirationsSitesLinks"
                  :key="index"
                  class="brief-form__table-link"
                >
                  <a :href="item.link" target="_blank">{{ item.link }}</a>
                  {{ item.description }}
                </span>
              </td>
            </tr>
            <tr>
              <td>Jakich funkcji od strony oczekujesz?</td>
              <td>
                <span
                  v-for="(item, index) in formData.siteFunctions"
                  :key="item"
                >
                  <template v-if="index !== 0">, </template> {{ item }}
                </span>
                <span v-if="formData.siteFunctionsLanguages">
                  <template v-if="formData.siteFunctionsLanguages.length > 0"
                    >,
                  </template>
                  strona w kilku językach: {{ formData.siteFunctionsLanguages }}
                </span>
              </td>
            </tr>
            <tr>
              <td>Czy oprócz strony potrzebujesz czegoś jeszcze?</td>
              <td>
                <span
                  v-for="(item, index) in formData.otherServices"
                  :key="item"
                >
                  <template v-if="item !== ''">
                    <template v-if="index !== 0">, </template>
                    {{ item }}</template
                  >
                </span>
              </td>
            </tr>
            <tr v-if="!formData.domainInfoSkip">
              <td>Domena</td>
              <td>
                {{
                  formData.domainInfo
                    ? formData.domainInfo
                    : 'nie posiadam domeny'
                }}
              </td>
            </tr>
            <tr>
              <td>Czy masz już wykupiony hosting?</td>
              <td>
                {{
                  formData.haveHosting
                    ? 'tak, mam hosting'
                    : 'nie, nie mam hostingu'
                }}
              </td>
            </tr>
            <tr>
              <td>Kiedy chciałbyś cieszyć się gotową stroną?</td>
              <td>{{ renderDate(formData.deadline) }}</td>
            </tr>
            <tr>
              <td>Jakim budżetem dysponujesz na tę realizację?</td>
              <td v-if="!formData.budgetSkip">
                {{ formData.budgetFrom }}zł - {{ formData.budgetTo }}zł
              </td>
              <td v-else>Nie wiem</td>
            </tr>
            <tr>
              <td>Skąd się o nas dowiedziałeś?</td>
              <td>
                <span
                  v-for="(item, index) in formData.findOutAboutUs"
                  :key="item"
                >
                  <template v-if="item !== ''">
                    <template v-if="index !== 0">, </template>
                    {{ item }}</template
                  >
                </span>
                <div v-if="formData.findOutAboutUsRecommendation">
                  z polecenia: 
                  {{ formData.findOutAboutUsRecommendation }},
                </div>
                <div v-if="formData.findOutAboutUsWebsite">
                  dzięki innej wykonanej przez Was stronie: 
                  {{ formData.findOutAboutUsWebsite }},
                </div>
                <div v-if="formData.findOutAboutUsOther">
                  inne: 
                  {{ formData.findOutAboutUsOther }},
                </div>
              </td>
            </tr>
            <tr v-if="!formData.importantToYouSkip">
              <td>Rzeczy, które są dla Ciebie istotne</td>
              <td>{{ formData.importantToYouDescription }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'Summary',
  components: { BriefStep },
  props: {
    formData: {
      type: Object,
      require: true,
    },
  },
  data: () => ({
    title: 'Podsumowanie',
  }),
  methods: {
    renderDate(payload) {
      const date = new Date(payload);
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      // eslint-disable-next-line operator-linebreak
      const month =
        Number(date.getMonth()) + 1 < 10
          ? `0${Number(date.getMonth()) + 1}`
          : date.getMonth() + 1;

      return `${day}.${month}.${date.getFullYear()}r.`;
    },
    emitStep() {
      this.$emit('is-valid', true);
    },
  },
};
</script>
<style lang="scss" scoped>
.brief-form {
  &__table {
    width: 100%;
    border-spacing: rem(0 20px);

    td {
      padding: rem(10px 14px);
      background: $white;
      vertical-align: baseline;

      img {
        max-width: rem(300px);
        max-height: rem(300px);
      }

      &:first-child {
        border-top-left-radius: 0.3125rem;
        border-bottom-left-radius: 0.3125rem;
        color: $purpleDim;

        @include media-min($sm) {
          width: 35%;
        }
      }

      &:last-child {
        border-top-right-radius: 0.3125rem;
        border-bottom-right-radius: 0.3125rem;
      }
    }
  }

  &__table-link {
    word-break: break-all;
    padding-bottom: rem(20px);
    border-bottom: rem(1px) solid #e7e7e7;
    margin-bottom: rem(20px);
    display: block;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }

    a {
      display: block;
      margin-bottom: rem(10px);
    }
  }
}
</style>
